<template>
  <VTextField
    ref="textField"
    :disabled="disabled"
    :modelValue="String(modelValue ?? '')"
    @update:modelValue="onInput"
    :placeholder="placeholder"
    type="tel"
    inputmode="numeric"
    :pattern="allowDecimal ? '[0-9.]*' : '[0-9]*'"
    @blur="handleInputEvent"
    @keydown="handleKeydown"
    @keypress="handleKeyPress($event)"
    :aria-label="ariaLabel"
    :class="inputClass"
    :maxlength="Number(maxlength)"
    appearance="ghost"
  />
</template>

<script>
import { useUIStore } from '@/stores/ui';

export default {
 emits:['update:modelValue', 'onChange'],
 props: {
   modelValue: {
     type: [String, Number],
     default: '',
   },
   disabled: {
     type: Boolean,
     default: false
   },
   slot: {
    type: String,
    default: 'start',
   },
   placeholder: {
    type: String,
    default: 'Placeholder',
   },
   ariaLabel: {
    type: String,
    default: 'aria-label',
   },
   inputClass: {
    type: String,
    default:'sctn-input'
   },
   maxlength: {
    type: [String, Number],
    default:'30'
   },
   min: {
    type: Number,
    default: 0
   },
   max: {
    type: Number,
    default: undefined
   },
   allowDecimal: {
    type: Boolean,
    default: false
   }
 },
 methods: {
    onInput(value) {
      this.$emit('update:modelValue', value);
    },
    handleInputEvent(event) {
      const value = String(this.modelValue);
      const numericValue = Number.parseInt(value);
      if (this.min !== undefined && numericValue < this.min) {
        useUIStore().updateToast({ open: true, message: "The minimum value allowed is " + this.min, type: "warning" });
        this.$emit('update:modelValue', this.min);
        return;
      }
      if (this.max !== undefined && numericValue > this.max) {
        useUIStore().updateToast({ open: true, message: "The maximum value allowed is " + this.max, type: "warning" });
        this.$emit('update:modelValue', this.max);
        return;
      }
      this.$emit('onChange');
    },
    handleKeydown(event) {
      const value = String(this.modelValue ?? '');
      if (value.length >= Number(this.maxlength) && event.key !== 'Backspace' && event.key !== 'Delete' && event.key !== 'ArrowLeft' && event.key !== 'ArrowRight' && event.key !== 'Tab') {
        event.preventDefault();
      }
    },
    handleKeyPress(event) {
      if ((!this.allowDecimal && event.key === '.') || event.key === '-' || event.key === 'e' || event.key === 'E' || event.key === ' ' || event.key === '+') {
        event.preventDefault();
      }
      // Block non-numeric characters
      if (!/\d/.test(event.key) && event.key !== '.' && event.key !== 'Backspace') {
        event.preventDefault();
      }
    }
 }
};
</script>

<style scoped>
.sctn-input {
  background: var(--background-primary);
  border-radius: 5px;
  min-height: 40px;
  width: 100%;
}

.sctn-input-discount {
  background: var(--background-primary);
  border-radius: 5px 0px 0px 5px;
  min-height: 40px;
  width: 100%;
}

.sctn-input-currency {
  background: var(--background-primary);
  border-radius: 0px 5px 5px 0px;
  min-height: 40px;
  width: 100%;
}
</style>
